import type { RouteParams } from 'vue-router';
import type { Breadcrumb, Product, ProductParams } from '@plentymarkets/shop-api';
import { productGetters, breadcrumbGetters } from '@plentymarkets/shop-api';

export const validateProductParams = (params: RouteParams): boolean => {
  const itemId = params.itemId as string;
  if (!itemId) return false;

  const pieces = itemId.split('_');
  if (pieces.length === 0 || pieces.length > 2) return false;
  if (!pieces[0] || isNaN(Number(pieces[0]))) return false;
  if (pieces.length === 2 && (!pieces[1] || isNaN(Number(pieces[1])))) return false;

  return true;
};

export const createProductParams = (params: RouteParams) => {
  const productPieces = (params.itemId as string).split('_');

  const productParams: ProductParams = {
    id: productPieces[0] ?? '',
  };

  if (productPieces[1]) {
    productParams.variationId = productPieces[1];
  }

  return { productParams, productId: productParams.id.toString() };
};

export const updateProductURLPathForVariation = (
  currentPath: string,
  itemId: string | number,
  variationId: string | number,
) => {
  const trailingSlash = currentPath.endsWith('/');
  const normalizedPath = trailingSlash ? currentPath.slice(0, -1) : currentPath;
  const pathSegments = normalizedPath.split('/');
  let lastSegment = pathSegments.pop();
  if (!lastSegment) return currentPath;

  const lastSegmentParts = lastSegment.split('_');
  const itemIdPosition = lastSegmentParts.length - 1;

  itemId = String(itemId);
  variationId = String(variationId);

  if (lastSegmentParts[itemIdPosition] === itemId) {
    lastSegmentParts.push(variationId);
  } else {
    lastSegmentParts[itemIdPosition] = variationId;
  }

  lastSegment = lastSegmentParts.join('_');
  pathSegments.push(lastSegment);

  const result = pathSegments.join('/');
  return trailingSlash ? result + '/' : result;
};

export const generateBreadcrumbs = (product: Product, home: string): Breadcrumb[] => {
  const breadcrumbs = breadcrumbGetters.mapFromCategoryBreadcrumbs(product.breadcrumbs ?? []);
  const productName = productGetters.getName(product);

  breadcrumbs.unshift({ name: home, link: '/' });
  breadcrumbs.push({ name: productName, link: `#` });

  return breadcrumbs;
};
